export interface SolanaConnectorProvider {
  id: string
  name: string
  walletName: string
}

export const getSolanaConnectorProviders = (): SolanaConnectorProvider[] => [
  { id: 'phantom', name: 'Phantom', walletName: 'Phantom' }
]
